<template>
  <editForm
    :key="mappedCloseOption + '|' + formsid"
    :formsesid="formsid"
    :requiredsubmit="false"
    :closeoption="mappedCloseOption"
    :isfieldvalidate="showpopup"
  />
</template>

<script src="./editform.js"></script>